import React from 'react';
import classNames from 'classnames';

import Trans from 'components/Common/Translation/Trans';

import styles from './RequiredFields.module.scss';

type Props = {
  as?: keyof JSX.IntrinsicElements;
  classes?: {
    wrapper?: string;
    asterisk?: string;
  };
};

export default function RequiredFields({ as, classes }: Props): JSX.Element {
  const Comp = as || 'div';

  return (
    <Comp className={classNames(styles.wrapper, classes?.wrapper)}>
      <Trans
        i18nKey={'FORM_REQUIRED_FIELDS'}
        additionalComponents={{
          e: <i className={classNames(styles.asterisk, classes?.asterisk)} />,
        }}
      />
    </Comp>
  );
}
